import { v4 } from 'uuid';

import {
  dispatchRequestInfo,
  executeQuery,
  executeTwoStepQuery,
  fetchJsonByPost,
  fetchTextByPost,
} from './execute';
import { fromRetentionResult } from '../converters/retentionConverter';
import {
  buildRetentionComplexQuery,
  buildRetentionComplexDashboardQuery,
  buildRetentionQuery,
  fromRetentionCsvResponse,
  buildRetentionDashboardQuery,
  getRetentionInfo,
} from '../converters/retentionApiConverter';
import { downloadCsv } from '../utils/common';
import { TABS } from '../constants/navigation';

const exposeRetention = (query, { backendUrl, accessToken, tokenType, tenantId }) =>
  fetchTextByPost(`/retention/query/expose`, query, {
    backendUrl,
    accessToken,
    tokenType,
    tenantId,
  });

const fetchRetention = (query, { backendUrl, accessToken, tokenType, tenantId }) =>
  fetchJsonByPost(`/retention/query`, query, { backendUrl, accessToken, tokenType, tenantId });

export const executeRetentionComplexQuery = (executeId) => (dispatch, getState) => {
  const state = getState();
  const query = buildRetentionComplexQuery(state);

  return executeTwoStepQuery(fetchRetention, query, executeId, dispatch, getState).then(
    (response) => ({
      result: fromRetentionResult(response),
      query,
    })
  );
};

export const exposeRetentionComplexQuery = () => (dispatch, getState) => {
  const state = getState();
  const query = buildRetentionComplexQuery(state);

  return executeQuery(exposeRetention, query, v4(), dispatch, getState).then((response) => ({
    sql: response,
  }));
};

export const executeRetentionComplexCsv = () => (dispatch, getState) => {
  const state = getState();
  const query = buildRetentionComplexQuery(state);
  const executeId = v4();
  const retentionInfo = getRetentionInfo(state);

  dispatchRequestInfo(
    executeId,
    dispatch,
    TABS.ADVANCED_RETENTION.title,
    [query.firstEvent, query.returnEvent],
    true
  );

  return executeTwoStepQuery(fetchRetention, query, executeId, dispatch, getState)
    .then((response) => fromRetentionCsvResponse(response, query, retentionInfo))
    .then(downloadCsv);
};

export const exposeRetentionQuery = () => (dispatch, getState) => {
  const state = getState();
  const query = buildRetentionQuery(state);
  return executeQuery(exposeRetention, query, v4(), dispatch, getState).then((response) => ({
    sql: response,
  }));
};

export const executeRetentionQuery = (executeId) => (dispatch, getState) => {
  const state = getState();
  const query = buildRetentionQuery(state);
  return executeTwoStepQuery(fetchRetention, query, executeId, dispatch, getState).then(
    (response) => ({
      result: fromRetentionResult(response),
      query,
    })
  );
};

export const executeRetentionQueryCsv = () => (dispatch, getState) => {
  const state = getState();
  const query = buildRetentionQuery(state);
  const executeId = v4();
  const retentionInfo = getRetentionInfo(state);

  dispatchRequestInfo(
    executeId,
    dispatch,
    TABS.RETENTION.title,
    [query.firstEvent, query.returnEvent],
    true
  );

  return executeTwoStepQuery(fetchRetention, query, executeId, dispatch, getState)
    .then((response) => fromRetentionCsvResponse(response, query, retentionInfo))
    .then(downloadCsv);
};

export const executeDashboardRetentionComplexQuery = (unit, executeId) => (dispatch, getState) => {
  const state = getState();
  const query = buildRetentionComplexDashboardQuery(state, unit);

  return executeTwoStepQuery(fetchRetention, query, executeId, dispatch, getState).then(
    (response) => ({
      result: fromRetentionResult(response),
      query,
      unit,
    })
  );
};

export const executeDashboardRetentionQuery = (unit, executeId) => (dispatch, getState) => {
  const state = getState();
  const query = buildRetentionDashboardQuery(state, unit);

  return executeTwoStepQuery(fetchRetention, query, executeId, dispatch, getState).then(
    (response) => ({
      result: fromRetentionResult(response),
      query,
      unit,
    })
  );
};
